import css from "@styled-system/css";
import React from "react";
import styled from "styled-components";
import { Half, Picture } from "../../Layout/Layout";
import { mobile } from "../../../theme";

import { Parent } from "../Questions";

import sunSrc from "../sun.svg";

const Answers = styled("div")(
  css({
    fontSize: [4, "88px"],
    fontWeight: "normal",
    marginBottom: [30, 15],
    backgroundImage: "linear-gradient(90deg, #7CFD34 0%, #1BC6AF 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  })
);

const Text = styled("div")(
  css({
    fontSize: [2, 3],
  })
);

const Content = styled("div")({
  textAlign: "center",
});

const Sun = styled("img")({
  display: "block",
  marginLeft: "auto",
  marginRight: "auto",
  [mobile]: {
    display: "none",
  },
});

export const Results = ({
  results,
  setResults,
  questions,
  active,
  answers,
  children,
}) => {
  const rightAnswers = results.filter((v, ix) => v === questions[ix][2]).length;
  const result = answers[active].find(([values]) =>
    values.includes(rightAnswers)
  );
  const [, imageSrc, no, title, text] = result;
  return (
    <Parent>
      {children}
      <Half css={{ alignItems: "center" }}>
        <Picture>
          <img alt="" src={imageSrc} />
        </Picture>
        <Content>
          <Sun src={sunSrc} />

          <Answers>{no}</Answers>
          <Text>
            <strong>{title}</strong>
            <br />
            {text}
          </Text>
        </Content>
      </Half>
    </Parent>
  );
};
